import { AutoComplete, AutoCompleteProps, Button, Card, Checkbox, DatePicker, Flex, 
    Form, Input, InputNumber, Radio, Select, Space, Steps, Table, Tabs, theme } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FacilityInterface, ResearcherInterface } from "../../model/IResearcher";
import { InvitedNewParticipant, InvitedParticipant } from "../../model/IprojectInfo";
import { useWatch } from 'antd/es/form/Form'; 
import axios from "axios";
import { motion, AnimatePresence } from 'framer-motion';
import { App } from 'antd';
import React from "react";
import dayjs from "dayjs";


const positions = [
    'อาจารย์',
    'บุคลากร',
    'นักศึกษาระดับปริญญาตรี',
    'นักศึกษาระดับปริญญาโท',
    'นักศึกษาระดับปริญญาเอก',
  ];
  
  

  type TargetKey = React.MouseEvent | React.KeyboardEvent | string;

export function EthicalReq()
{   
    const [project_status,setProjectStatus] = useState('');
    const [facData,setFacData] = useState<FacilityInterface[]>([])
    const [current, setCurrent] = useState(0);
    const [researcher_position, setresearcher_position] = useState('');
    const [otherPosition,setOtherPosition] = useState('');
    const [project_type, setproject_type] = useState('');
    const [Otherproject_type, setOtherproject_type] = useState('');
    const [IsTool, setIsTool] = useState('');
    const [form] = Form.useForm();
    const isEducation = Form.useWatch('IsAcademicResearch', form);
    const IsJoinPer = !Form.useWatch('IsJoinPer', form); 
    const IsbloodDraw = Form.useWatch('IsbloodDraw', form); 
    const [IsInvasiveProcedure,setIsInvasiveProcedure] = useState('')
    const [ResMat, setResMat] = useState('');
    const [IsMedicine, setIsMedicine] = useState('');
    const [MedicineInfo, setMedicineInfo] = useState('');
    const [ResMatReason, setResMatReason] = useState('');
    const { message,notification } = App.useApp();
    const [invitedParticipant, setInvitedParticipant] = useState<InvitedParticipant>({
        healthy: {
          count: null,
          note:'',
          age:'',
          age_year: null,
          age_month: null,
          gender: [],
        },
        patient: {
          count: null,
          note:'',
          age:'',
          age_year: null,
          age_month: null,
          gender: [],
        },
        other: {
        othertype:'',
          count: null,
          note:'',
          age:'',
          age_year: null,
          age_month: null,
          gender: [],
        },
      });

    const [NewinvitedParticipant, setNewInvitedParticipant] = useState<InvitedNewParticipant>({
        normal: {
            count: null,
            note:'',
            age:'',
            age_year: null,
            age_month: null,
            gender: [],
            },
        kids: {
        count: null,
        note:'',
        age:'',
        age_year: null,
        age_month: null,
        gender: [],
        },
        vulnerable: {
        count: null,
        note:'',
        age:'',
        age_year: null,
        age_month: null,
        gender: [],
        },
    });
    
    const [hidingPatient, setHidingPatient] = useState(false);
    const [selectedTypes, setSelectedTypes] = useState<string[]>([]);
    const genderOptions = ['ชาย', 'หญิง'];
    const [plagiaisme, setplagiaisme] = useState('');
    const [plagiaismDes, setplagiaismDes] = useState('');
    const [isJoined,setIsJoined] = useState(false);
    const [HeadResData,setHeadResdata] = useState<ResearcherInterface>();
    const [activeKey, setActiveKey] = useState('0');
    const [Sponser,setSponser] = useState('')
    const [SponserExplanation,setSponserExplanation] = useState('')
    const [IsQuestionairReason,setIsQuestionairReason] = useState('');
    const [IsCountryReligionRiskFactor,setIsCountryReligionRiskFactor] = useState('')
    const [CountryReligionRiskFactorList,setIsCountryReligionRiskFactorList] = useState('')
    const isDisabledStudent =
    sessionStorage.getItem('POS_ID') !== null &&
    sessionStorage.getItem('POS_ID') !== ''
    const isInside = 
        sessionStorage.getItem('status') == 'Insider'
    const handleInputChange = <K extends keyof ResearcherInterface>(
        index: number,
        field: K,
        value: ResearcherInterface[K]
      ) => {
        const updated = [...JoinedResearcher];
        updated[index][field] = value;
        setJoinedResearcher(updated);
        console.log(updated)
      };

      const [options, setOptions] = React.useState<AutoCompleteProps['options']>([]);
      const handleSearch = (value: string) => {
        setOptions(() => {
        if (!value || value.includes('@')) {
            return [];
        }
        return ['gmail.com', 
                'yahoo.com', 
                'hotmail.com', 
                'outlook.com', 
            ].map((domain) => ({
            label: `${value}@${domain}`,
            value: `${value}@${domain}`,
        }));
        });
    };



  const handleJoinPerChange = (index: number, value: number|null ) => {
    if (index === 0) {
      // update HeadResData join_per
      setHeadResdata((prev: any) => ({ ...prev, join_per: value }));
    } else {
      const researcherIndex = index - 1;
      if (researcherIndex >= 0 && researcherIndex < JoinedResearcher.length) {
        const updated = [...JoinedResearcher];
        updated[researcherIndex] = {
          ...updated[researcherIndex],
          join_per: value ?? 0,
        };
        setJoinedResearcher(updated);
      }
    }
  };
  
    const [JoinedResearcher, setJoinedResearcher] = useState<ResearcherInterface[]>([
        {
          Researcher_ID: 0,
          user_ID: '',
          researcher_THname: '',
          researcher_ENname: '',
          posname: '',
          IsInsider:0,
          researcher_facility: '',
          researcher_address: '',
          researcher_wp: '',
          researcher_tel: '',
          researcher_wptel: '',
          researcher_phone: '',
          researcher_email: '',
          join_per: 0,
          role: '',
          projectID: '',
        },
      ]);
      const items = JoinedResearcher.map((researcher, index) => ({
        label: `ผู้ร่วมวิจัยคนที่ ${index + 1}`,
        key: `${index}`,
        children: (
          <Form layout="vertical">
            <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  label="ชื่อ (ภาษาไทย)">
              <Input
                style={{marginLeft:50}}
                value={researcher.researcher_THname}
                placeholder={'กรุณากรอกชื่อ (ภาษาไทย) ของผู้ร่วมวิจัย'}
                onChange={(e) => handleInputChange(index, 'researcher_THname', e.target.value)}
              />
            </Form.Item>
            <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  label="ชื่อ (ภาษาอังกฤษ)">
              <Input
                style={{marginLeft:50}}
                value={researcher.researcher_ENname}
                placeholder={'กรุณากรอกชื่อ (ภาษาอังกฤษ) ของผู้ร่วมวิจัย'}
                onChange={(e) => handleInputChange(index, 'researcher_ENname', e.target.value)}
              />
            </Form.Item>
            <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  label="เป็นบุคลากรภายในมหาวิทยาลัยวงษ์ชวลิตกุลหรือไม่">
                <Radio.Group 
                value={researcher.IsInsider}
                onChange={(e) => handleInputChange(index, 'IsInsider', e.target.value)}
                options={[{
                    label:'ใช่',value:"1"
                },
                {
                    label:'ไม่',value:"0"
                }
            ]}
                />
            </Form.Item>
            <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  label="ตำแหน่ง">
            <Radio.Group
                value={!positions.includes(researcher.posname || '') ? 'อื่นๆ' : researcher.posname}
                onChange={(e) => {
                const value = e.target.value;
                if (value !== 'อื่นๆ') {
                    handleInputChange(index, 'posname', value);
                } else {
                    handleInputChange(index, 'posname', ''); // clear for typing
                }
                }}
                style={{ display: 'flex', flexDirection: 'column', gap: 8,marginLeft:50 }}
            >
                {positions.map((pos) => (
                <Radio key={pos} value={pos}>
                    {pos}
                </Radio>
                ))}

                <Radio value="อื่นๆ">
                อื่นๆ
                {!positions.includes(researcher.posname || '') && (
                    <Input
                    placeholder="กรุณาระบุ"
                    style={{ width: '30vw', marginInlineStart: 12 }}
                    value={researcher.posname}
                    onChange={(e) =>
                        handleInputChange(index, 'posname', e.target.value)
                    }
                    />
                )}
                </Radio>
            </Radio.Group>
            </Form.Item>

            
            <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  label="สังกัด">
              <Input
                style={{marginLeft:50}}
                value={researcher.researcher_facility}
                placeholder={'กรุณากรอกสังกัดของผู้ร่วมวิจัย'}

                onChange={(e) => handleInputChange(index, 'researcher_facility', e.target.value)}
              />
            </Form.Item>
           
            <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  label="เบอร์โทรศัพท์มือถือ">
              <Input
                style={{marginLeft:50}}
                value={researcher.researcher_phone}
                placeholder={'กรุณากรอกเบอร์โทรศัพท์มือถือของผู้ร่วมวิจัย'}
                onChange={(e) => handleInputChange(index, 'researcher_phone', e.target.value)}
              />
            </Form.Item>
            <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  label="Email">
            <AutoComplete
                style={{marginLeft:50}}
                value={researcher.researcher_email}
                onChange={(value) => handleInputChange(index, 'researcher_email', value)}
                onSearch={handleSearch}
                options={options}
                placeholder={'กรุณากรอก Email ของผู้ร่วมวิจัย'}
                />
            </Form.Item>
          </Form>
        ),
      }));
      const participants = [
        {
          order_id: 1,
          researcher_THname: form.getFieldValue('researcher_THname') || 'error',
          join_per: HeadResData?.join_per || 0,
        },
        ...(isJoined
            ? JoinedResearcher.map((r, idx) => ({
                order_id: idx + 2, // head is order 1
                researcher_THname: r.researcher_THname,
                join_per: r.join_per || 0,
              }))
            : []),
      ];
    const newTabIndex = useRef(0);
    const navigate = useNavigate();
    
    
    const { token } = theme.useToken();
    const style: React.CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        marginLeft: '40px',
        fontWeight:'normal'
      };

      useEffect(() => {
        const FaciData = sessionStorage.getItem('POS_ID');
        const name = sessionStorage.getItem('fullname') || '';
        form.setFieldsValue({ researcher_THname: name });
        if (FaciData) {
            const TmpFacData = JSON.parse(FaciData)
            console.log(TmpFacData)
            setFacData(TmpFacData);
            
        }


        axios.get(`${process.env.REACT_APP_BASE}/getFullProjectInfo/${sessionStorage.getItem('Order_ID')}/${sessionStorage.getItem('user')}`).then(response=>{
            if(response.status==200)
                {   
                    const tmpdata = response.data.data

                    setProjectStatus(response.data.data.project_status)
                    setIsTool(tmpdata.IsQuestionair)
                    setIsQuestionairReason(tmpdata.IsQuestionairReason)
                    if(response.data.data.researcher_THname){
                        form.setFieldsValue({ researcher_THname: response.data.data.researcher_THname });
                    }
                    form.setFieldsValue({
                        ...tmpdata,
                        ResearchStartingDate: tmpdata.ResearchStartingDate
                          ? dayjs(tmpdata.ResearchStartingDate)
                          : dayjs(),
                        ResearchEndingDate: tmpdata.ResearchEndingDate
                          ? dayjs(tmpdata.ResearchEndingDate)
                          : dayjs(),
                        InfoGatheringStartingDate: tmpdata.InfoGatheringStartingDate
                          ? dayjs(tmpdata.InfoGatheringStartingDate)
                          : dayjs(),
                        InfoGatheringEndingDate: tmpdata.InfoGatheringEndingDate
                          ? dayjs(tmpdata.InfoGatheringEndingDate)
                          : dayjs(),
                        IsJoinPer: tmpdata.IsJoinPer === 'true',
                        LangRecieve: tmpdata.LangRecieve 
                        ? JSON.parse(tmpdata.LangRecieve) 
                        : undefined
                      });
                      setSponser(tmpdata.Sponsor)
                      setSponserExplanation(tmpdata.SponsorNote)
                    form.setFieldValue('applicableFactor',JSON.parse(tmpdata.applicableFactor))
                    setresearcher_position(tmpdata.posname)
                    setResMat(tmpdata.IsCommercialInterlectualProperty)
                    setResMatReason(tmpdata.ComIntDesc)
                    setplagiaisme(tmpdata.PlagiarismPer)
                    setplagiaismDes(tmpdata.PlagiarismDesc)
                    if(tmpdata.InvitedParticipant!=null&&tmpdata.InvitedParticipant!=''){
                        form.setFieldsValue(JSON.parse(tmpdata.InvitedParticipant))
                        const data = JSON.parse(tmpdata.InvitedParticipant);

                        const invitedTypes: string[] = [];
                        if (data?.patient) invitedTypes.push('ผู้ป่วย');
                        if (data?.healthy) invitedTypes.push('ผู้มีสุขภาพดี');
                        if (data?.other) invitedTypes.push('อื่น ๆ');
                        if (data?.normal) invitedTypes.push('อาสาสมัครทั่วไป');
                        if (data?.kids) invitedTypes.push('อาสาสมัครเด็ก อายุ 7-18 ปี');
                        if (data?.vulnerable) invitedTypes.push('อาสาสมัครกลุ่มเปราะบาง');
                        console.log(data)
                        console.log(invitedTypes)
                        setSelectedTypes(invitedTypes)
                        form.setFieldsValue({
                            Invited:invitedTypes
                        });
                        form.setFieldsValue({
                            InvitedParticipant:data
                        });
                    }
                    console.log(tmpdata.project_type)
                    if(tmpdata.project_type){
                        if(tmpdata.project_type!='งานวิจัยในงานประจำ'||
                            tmpdata.project_type!='โครงการวิจัยที่เสนอขอรับทุน'
                        ){
                            setproject_type('อื่นๆ')
                            setOtherproject_type(tmpdata.project_type)
                        }else{
                            setproject_type(tmpdata.project_type)
                        }
                    }
                    console.log(tmpdata.ResearchStartingDate)

                    setIsInvasiveProcedure(tmpdata.IsInvasiveProcedure)

                    const Joined = response.data.Joined
                    console.log(Joined)
                    if(Joined.length!=0){
                        setIsJoined(true)
                        setJoinedResearcher(
                            Joined.map((item: { joinper: any; }) => ({
                              ...item,
                              join_per: item.joinper,
                            }))
                          );
                    }
                    const head = response.data.Head
                    setHeadResdata({
                        ...head,
                        join_per:head.joinper
                    })
                    if(tmpdata.IsCountryReligionRiskFactor){
                        setIsCountryReligionRiskFactor(tmpdata.IsCountryReligionRiskFactor)
                        setIsCountryReligionRiskFactorList(tmpdata.CountryReligionRiskFactor)
                    }
                    if(tmpdata.IsMedicine){
                        setIsMedicine(tmpdata.IsMedicine)
                    }
                    if(tmpdata.MedicineInfo){
                        setMedicineInfo(tmpdata.MedicineInfo)
                    }
                }
        })
      }, []);
 

      const onEdit = (
        targetKey: string | React.MouseEvent | React.KeyboardEvent,
        action: 'add' | 'remove'
      ) => {
        if (action === 'add') {
            const id = JoinedResearcher.length
          const newResearcher: ResearcherInterface = {
            Researcher_ID: id,
            user_ID: '',
            researcher_THname: '',
            researcher_ENname: '',
            posname: '',
            IsInsider:0,
            researcher_facility: '',
            researcher_address: '',
            researcher_wp: '',
            researcher_tel: '',
            researcher_wptel: '',
            researcher_phone: '',
            researcher_email: '',
            join_per: 0,
            role: '',
            projectID: '',
          };
          const newList = [...JoinedResearcher, newResearcher];
          setJoinedResearcher(newList);
          setActiveKey((newList.length - 1).toString());
        } else if (action === 'remove') {
          if (typeof targetKey === 'string') {
            const index = parseInt(targetKey, 10);
            const newList = JoinedResearcher.filter((_, i) => i !== index);
            setJoinedResearcher(newList);
            setActiveKey('0');
          }
        }
      };
      
    const TabsonChange = (newActiveKey: string) => {
        setActiveKey(newActiveKey);
    };

    const onChange = (value: number) => {
        setCurrent(value);
      };

    const PositiononChange = (e: any) => {
        setresearcher_position(e.target.value);
      };
      const EduonChange = (e: any) => {
        setproject_type(e.target.value);
      };
      const ToolOnChange = (e: any) => {
        setIsTool(e.target.value);
      };
      const ResMatOnChange = (e: any) => {
        setResMat(e.target.value);
      };
      const plagiaismeOnChange = (e: any) => {
        setplagiaisme(e.target.value);
      };

      const handleResearchDateChange = () => {
        const start = form.getFieldValue('ResearchStartingDate');
        const end = form.getFieldValue('ResearchEndingDate');
      
        if (start && end) {
          const totalMonths = end.diff(start, 'month') + 1; // include start month
          const years = Math.floor(totalMonths / 12);
          const months = totalMonths % 12;
      
          form.setFieldsValue({
            ResearchPeriod_year: years,
            ResearchPeriod_month: months
          });
        }
      };

      const handleInfoDateChange = () => {
        const start = form.getFieldValue('InfoGatheringStartingDate');
        const end = form.getFieldValue('InfoGatheringEndingDate');
      
        if (start && end) {
          const totalMonths = end.diff(start, 'month') + 1; // include start month
          const years = Math.floor(totalMonths / 12);
          const months = totalMonths % 12;
      
          form.setFieldsValue({
            InfoGatheringPeriod_year: years,
            InfoGatheringPeriod_month: months
          });
        }
      };

    async function saveProtoptype(){
        const FormData = form.getFieldsValue();
        console.log(FormData)
        let data
        if(current==0){
            data = {
                part:'part1.1',
                project_nameTH:FormData.project_nameTH,
                project_nameEN:FormData.project_nameEN,
                researcher_THname:FormData.researcher_THname,
                researcher_ENname:FormData.researcher_ENname,
                researcher_position:researcher_position==='อื่นๆ' &&researcher_position||researcher_position,
                researcher_facility:FormData.researcher_facility,
                researcher_phone:FormData.researcher_phone,
                researcher_email:FormData.researcher_email,
                IsJoinPer:FormData.IsJoinPer,
                isJoined:isJoined,
                participants:participants.length>0&&participants||'',
                JoinedResearchers:isJoined&&JoinedResearcher||'',
                Advicer_Name:FormData.advice_Name,
                Advicer_fac:FormData.advice_fac,
                Advicer_PhoneNum:FormData.advice_PhoneNum,
                Advicer_Email:FormData.advice_Email,
                is_for_education:FormData.IsAcademicResearch,
                education_level:FormData.education_level,
                project_type:project_type=='อื่นๆ'&&Otherproject_type||project_type,
                IsQuestionair:IsTool,
                IsQuestionairReason:IsQuestionairReason,
                ResearchPeriod_year:FormData.ResearchPeriod_year,
                ResearchPeriod_month:FormData.ResearchPeriod_month,
                ResearchStartingDate:FormData.ResearchStartingDate,
                ResearchEndingDate:FormData.ResearchEndingDate,
                InfoGatheringPeriod_year:FormData.InfoGatheringPeriod_year,
                InfoGatheringPeriod_month:FormData.InfoGatheringPeriod_month,
                InfoGatheringStartingDate:FormData.InfoGatheringStartingDate,
                InfoGatheringEndingDate:FormData.InfoGatheringEndingDate,
                Projectfund:FormData.Projectfund,
                EthicalApprovalFee:FormData.EthicalApprovalFee,
                Sponsor:FormData.Sponsor,
                SponsorNote:SponserExplanation
            }

            console.log(data)


        }else if(current==1){
            data ={
                part:'part1.2',
                InvitedParticipant:FormData.InvitedParticipant,
                IsbloodDraw:FormData.IsbloodDraw,
                BlooddrawObjective:FormData.bloodDrawObjective,
                bloodDrawTimes:FormData.bloodDrawTimes,
                bloodDrawAmount:FormData.bloodDrawAmount,
                bloodDrawUnit : FormData.bloodDrawUnit,
                bloodDrawTotalTimes:FormData.bloodDrawTotalTimes,
                bloodDrawTotalMonth:FormData.bloodDrawTotalMonth,
                IsInvasiveProcedure:IsInvasiveProcedure,
                InvasiveProcedureSummary:FormData.InvasiveProcedureSummary,
                RiskAndUncomfortableFactor:FormData.RiskAndUncomfortableFactor,
                DefensiveMeasure:FormData.DefensiveMeasure,
                ExpenseCoverage:FormData.ExpenseCoverage,
                AcceptanceUnderstanding:FormData.AcceptanceUnderstanding,
                IsCountryReligionRiskFactor:IsCountryReligionRiskFactor,
                CountryReligionRiskFactorList:CountryReligionRiskFactorList
            }
            console.log(data)
        }else if(current==2){
            data ={
                part:'part1.3',
                IsMedicine:IsMedicine,
                MedicationInfo:MedicineInfo,
                applicableFactor:FormData.applicableFactor,
                applicableFactorDesc:FormData.applicableFactorDesc,
            }
            console.log(data)
        }else if(current==3){
            data ={
                part:'part1.4',
                ResMat:ResMat,
                ResMatReason:ResMatReason,
                ProgressReport:FormData.ProgressReport,
                isPlagiarism:plagiaisme,
                PlagiarismDesc:plagiaismDes,
            }
        }else if(current==4){
            data = {
                part:'part1.5',
                Acceptance:FormData.Acceptance,
                LangRecieve:FormData.LangRecieve,
            }
        }
        await axios.post(`${process.env.REACT_APP_BASE}/SaveEdit/${sessionStorage.getItem('Order_ID')}/${sessionStorage.getItem('user')}`,data).then(response=>{
            if(response.status==200){
                notification.success({
                    message: 'บันทึกสำเร็จ',
                    description: 'ข้อมูลของคุณถูกบันทึกเรียบร้อยแล้ว',
                  });
            }else{
                notification.error({
                    message: 'บันทึกไม่สำเร็จ',
                    description: 'กรุณาตรวจสอบข้อมูลของท่าน',
                  });
            }}
        )
    }

    const ReqStep = [
        {
            title:'ส่วนที่ 1',
            content:
            
                <div style={{padding:20}}>
                    <h2>ส่วนที่ 1 ข้อมูลทั่วไป</h2>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} name='project_nameTH' label='ชื่อโครงการวิจัย'>
                        <Input value={''} style={{marginLeft:50}} placeholder="ชื่อโครงการวิจัยภาษาไทย"/>
                    </Form.Item>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name='project_nameEN'>
                        <Input style={{marginLeft:50}} placeholder="ชื่อโครงการวิจัยภาษาอังกฤษ"/>
                    </Form.Item>
                    <hr style={{ border: "1px dashed #ccc" }} />

                    <p style={{fontWeight:'bold',fontSize:20}}><u>ข้อมูลสมาชิกโครงการวิจัย</u></p>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} name='researcher_THname' label='ชื่อหัวหน้าโครงการวิจัย'>
                        <Input
                            disabled={sessionStorage.getItem('status') == 'Insider'}
                            style={{ marginLeft: 50 }}
                            placeholder="ชื่อหัวหน้าโครงการวิจัยภาษาไทย"
                            />
                    </Form.Item>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name='researcher_ENname'>
                        <Input style={{marginLeft:50}} placeholder="ชื่อหัวหน้าโครงการวิจัยภาษาอังกฤษ"/>
                    </Form.Item>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} label='ตำแหน่งหัวหน้าโครงการวิจัย'>
                        <Radio.Group
                            style={style}
                            value={researcher_position}
                            onChange={PositiononChange}
                            options={[
                                { value: 'อาจารย์', label: 'อาจารย์', disabled:!isDisabledStudent&&isInside },
                                { value: 'บุคลากร', label: 'บุคลากร', disabled:!isDisabledStudent&&isInside },
                                { value: 'นักศึกษาระดับปริญญาตรี', label: 'นักศึกษาระดับปริญญาตรี' , disabled:isDisabledStudent&&isInside },
                                { value: 'นักศึกษาระดับปริญญาโท', label: 'นักศึกษาระดับปริญญาโท', disabled:isDisabledStudent&&isInside },
                                { value: 'นักศึกษาระดับปริญญาเอก', label: 'นักศึกษาระดับปริญญาเอก', disabled:isDisabledStudent&&isInside},
                                {
                                    value:'อื่นๆ',
                                    label: (
                                        <Flex>
                                          อื่นๆ
                                          {researcher_position === 'อื่นๆ' && (
                                            <AnimatePresence>
                                                <motion.div
                                                    key="bloodCard"
                                                    initial={{ opacity: 0, y: -20 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    exit={{ opacity: 0, y: -20 }}
                                                    transition={{ duration: 0.3 }}
                                                    >
                                                <Input
                                                    value={otherPosition}
                                                    onChange={(e)=>setOtherPosition(e.target.value)}
                                                variant="filled"
                                                placeholder="กรุณาระบุ"
                                                style={{ width: '30vw', marginInlineStart: 12 }}
                                                /></motion.div>
                                            </AnimatePresence>
                                          )}
                                        </Flex>
                                      )
                                },
                            ]}/>
                    </Form.Item>
                    
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} name='researcher_facility' label='สังกัดหัวหน้าโครงการวิจัย '>
                        {isDisabledStudent&&
                            <Select 
                                style={{marginLeft: '40px'}}
                                options={
                                facData.map((item)=>( 
                                    { value: item.Fac_NameTH, label:item.Fac_NameTH }))
                            }/>||
                            <Input style={{marginLeft: '40px'}}/>
                        }
                    </Form.Item>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} name='researcher_phone' label='เบอร์โทรศัพท์ติดต่อหัวหน้าโครงการวิจัย '>
                        <Input style={{marginLeft:50}} placeholder="เบอร์โทรศัพท์ติดต่อหัวหน้าโครงการวิจัย "/>
                    </Form.Item>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} name='researcher_email' label='Email หัวหน้าโครงการวิจัย '>
                        <AutoComplete
                        style={{marginLeft: '40px'}}
                            onSearch={handleSearch}
                            options={options}
                            placeholder={'Email หัวหน้าโครงการวิจัย'}
                            />
                    </Form.Item>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]} 
                        style={{ fontWeight: 'bold' }}
                        name="IsJoinPer"
                        label="สัดส่วนภาระงาน (กรณีที่มีการตีพิมพ์ในวารสาร)"
                        valuePropName="checked">
                        <Checkbox style={{ marginLeft: 50, fontWeight: 'normal' }}>
                            ไม่สามารถจัดแบ่งได้เพราะเป็นการวิจัยแบบพหุสถาบัน/หลายประเทศ
                        </Checkbox>
                    </Form.Item>
                    <AnimatePresence>
                    {IsJoinPer&&
                        <motion.div
                            key="bloodCard"
                            initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -20 }}
                            transition={{ duration: 0.3 }}
                            >
                            <Form.Item required
                            rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}}>
                                <Table columns={[
                                    {
                                        title:'ลำดับ',
                                        width:'5vw',
                                        key:'order_id',
                                        dataIndex:'order_id'
                                    },
                                    {
                                        title:'ชื่อผู้มีส่วนร่วม',
                                        key:'researcher_THname',
                                        dataIndex:'researcher_THname'
                                    },
                                    {
                                        title: 'สัดส่วนภาระงานร้อยละ',
                                        key: 'join_per',
                                        dataIndex: 'join_per',
                                        width:'10vw',
                                        render: (__, record, index) => (
                                        <InputNumber
                                            value={record.join_per}
                                            onChange={(value) => handleJoinPerChange(index, value)}
                                        />
                                        ),
                                    },
                                    ]}
                                    pagination={false}
                                    dataSource={participants}
                                    />
                                {participants.reduce((sum, p) => sum + (p.join_per || 0), 0) !== 100 && (
                                    <Card style={{ color: 'red', marginTop: '10px',alignContent:'center' }}>
                                        <p>สัดส่วนภาระงานต้องค่ารวม 100 เปอร์เซ็นต์</p>
                                        <p>คุณสามารถบันทึกงานได้แต่จะไม่สามารถยื่นขอจริยธรรมได้จนกว่าคุณจะกรอกค่าให้ครบ 100 เปอร์เซ็นต์</p>
                                    </Card>
                                )}
                            </Form.Item>
                        </motion.div>
                    }</AnimatePresence>
                    <br/>
                    {  project_status !='แก้ไขข้อมูลตามผลพิจารณา'&&
                        <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}}  label='โครงการของท่านมีผู้ร่วมวิจัยหรือไม่'>
                        <Radio.Group
                            value={isJoined}
                            onChange={(e)=>{
                                setIsJoined(e.target.value)
                            }}
                            style={{
                                flexDirection: 'column',
                                gap: 8,
                                marginLeft: '40px',
                                fontWeight:'normal'
                            }}
                            options={[{
                                    label:'ใช่',value:true
                                },
                                {
                                    label:'ไม่',value:false
                                }
                            ]}/>
                            <br/>
                        </Form.Item>}
                    
                    <AnimatePresence>
                    {isJoined&&
                    <motion.div
                        key="bloodCard"
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.3 }}
                        >
                        {  project_status !='แก้ไขข้อมูลตามผลพิจารณา'&&<Tabs
                                type="editable-card"
                                activeKey={activeKey}
                                onChange={(key) => setActiveKey(key)}
                                onEdit={onEdit}
                                items={items}
                            />||
                                <Tabs
                                activeKey={activeKey}
                                onChange={(key) => setActiveKey(key)}
                                items={items}
                                />}
                        </motion.div>
                        }
                    </AnimatePresence>
                        <br/>
                    <hr style={{ border: "1px dashed #ccc" }} />

                    {['นักศึกษาระดับปริญญาตรี', 'นักศึกษาระดับปริญญาโท', 'นักศึกษาระดับปริญญาเอก'].includes(researcher_position)&&<><p style={{fontWeight:'bold'}}>อาจารย์ที่ปรึกษาโครงการ</p>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} name='advice_Name' label='ชื่ออาจารย์ที่ปรึกษา'>
                        <Input style={{marginLeft:50}} placeholder="ชื่ออาจารย์ที่ปรึกษา"/>
                    </Form.Item>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} name='advice_fac' label='สังกัดอาจารย์ที่ปรึกษา'>
                        <Input style={{marginLeft:50}} placeholder="สังกัดอาจารย์ที่ปรึกษา"/>
                    </Form.Item>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} name='advice_PhoneNum' label='เบอร์โทรศัพท์ติดต่ออาจารย์ที่ปรึกษา'>
                        <Input style={{marginLeft:50}} placeholder="เบอร์โทรศัพท์ติดต่ออาจารย์ที่ปรึกษา"/>
                    </Form.Item>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} name='advice_Email' label='Email อาจารย์ที่ปรึกษา'>
                        <AutoComplete
                        style={{marginLeft: 50,fontWeight:'normal'}}
                            onSearch={handleSearch}
                            options={options}
                            placeholder={'Email อาจารย์ที่ปรึกษา'}
                            />
                    </Form.Item>
                    
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} name='IsAcademicResearch' label='โครงการนี้เป็นโครงการวิจัยเพื่อการศึกษาหรือไม่'>
                            <Radio.Group style={style} options={[
                                {value:'ใช่',label:"ใช่"},
                                {value:'ไม่ใช่',label:'ไม่ใช่'},
                            ]}/>
                    </Form.Item>
                        {isEducation === 'ใช่' && (
                            <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]} 
                                style={{ fontWeight: 'bold' }}
                                name="education_level"
                                label="โครงการวิจัยนี้ใช้เป็นส่วนหนึ่งของการสำเร็จการศึกษา ระดับ"
                                >
                                <Select
                                    style={{ marginLeft: 50, fontWeight: 'normal' }}
                                    placeholder="กรุณาเลือกระดับการศึกษา"
                                    options={[
                                    { value: 'ปริญญาตรี', label: 'ปริญญาตรี' },
                                    { value: 'ปริญญาโท', label: 'ปริญญาโท' },
                                    { value: 'ปริญญาเอก', label: 'ปริญญาเอก' },
                                    ]}
                                />
                                </Form.Item>
                            )}
                        </>}
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} label='โครงการนี้เป็นโครงการวิจัยประเภท'>
                        <Radio.Group
                            style={style}
                            value={project_type}
                            onChange={EduonChange}
                            options={[
                                {
                                    label:'งานวิจัยในงานประจำ',value:'งานวิจัยในงานประจำ'
                                },
                                {
                                    label:'โครงการวิจัยที่เสนอขอรับทุน',value:'โครงการวิจัยที่เสนอขอรับทุน'
                                },
                                {
                                    value:'อื่นๆ',
                                    label: (
                                        <>
                                        อื่นๆ
                                        {project_type === 'อื่นๆ' && (
                                            <Input
                                            value={Otherproject_type}
                                            onChange={(e)=>setOtherproject_type(e.target.value)}
                                            variant="filled"
                                            placeholder="กรุณาระบุ"
                                            style={{ width: '30vw', marginInlineStart: 12 }}
                                            />
                                        )}
                                        </>
                                    )
                                },
                            ]}/>
                    </Form.Item>
                    <Form.Item required
                    rules={[{ required: true, message: 'เลือกข้อมูล' }]}  style={{fontWeight:'bold'}} label='ผู้วิจัยมีโครงร่างงานวิจัย และแบบสอบถาม หรือเครื่องมือวิจัย เพื่อประกอบการพิจารณาจริยธรรมการวิจัยในมนุษย์'>
                        <Radio.Group
                            style={style}
                            value={IsTool}
                            onChange={ToolOnChange}
                            options={[
                                {
                                    label:'มี',value:'มี'
                                },
                                {
                                    value:'ไม่มี',label:(
                                        <>
                                          ไม่มี 
                                          {IsTool === 'ไม่มี' && (<>
                                            เพราะ
                                            <Input
                                              value={IsQuestionairReason}
                                              onChange={(e)=>setIsQuestionairReason(e.target.value)}
                                              variant="filled"
                                              placeholder="กรุณาระบุเหตุผลประกอบ"
                                              style={{ width: '30vw', marginInlineStart: 12 }}
                                            /></>
                                          )}
                                        </>
                                      )
                                },
                             
                            ]}/>
                    </Form.Item>

                    <p style={{fontWeight:'bold'}}>ระยะเวลา</p>
                    <Card style={{marginLeft:20}}>
                    
                        <br/>
                    <Flex align="center" gap={8} style={{ marginLeft: 20 }}>
                        <p>ดำเนินโครงการวิจัยเริ่มตั้งแต่เดือน</p>
                        <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]} 
                            name="ResearchStartingDate"
                            style={{ marginBottom: 0 }}
                            >
                            <DatePicker
                                picker="month"
                                format="MMMM YYYY"
                                placeholder="เลือกเดือนเริ่มต้น"
                                onChange={handleResearchDateChange}
                                style={{ width: 160 }}
                            />
                        </Form.Item>
                        <p>จนถึงเดือน</p>
                        <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]} 
                        name="ResearchEndingDate"
                        style={{ marginBottom: 0 }}
                        >
                        <DatePicker
                            picker="month"
                            format="MMMM YYYY"
                            placeholder="เลือกเดือนสิ้นสุด"
                            style={{ width: 160 }}
                            onChange={handleResearchDateChange}
                            disabledDate={(currentitem) => {
                                const start = form.getFieldValue('ResearchStartingDate');
                                return start && currentitem < start.startOf('month');
                                }}
                        />
                        </Form.Item>
                    </Flex>
                    <Flex align="center" gap={8} style={{ marginLeft: 20 }}>
                        <p>ระยะเวลาดำเนินโครงการวิจัย</p>
                            <Form.Item required
                            rules={[{ required: true, message: 'กรุณาเลือกวันเวลาเริ่มต้น/สิ้นสุดการดำเนินงาน' }]} 
                                name="ResearchPeriod_year"
                                style={{ marginBottom: 0 }}
                            >
                                <InputNumber min={0} style={{ width: 60 }} disabled/>
                            </Form.Item>
                            <p>ปี</p>
                            <Form.Item required
                                 rules={[{ required: true, message: 'กรุณาเลือกวันเวลาเริ่มต้น/สิ้นสุดการดำเนินงาน' }]} 
                                name="ResearchPeriod_month"
                                style={{ marginBottom: 0 }}
                            >   
                                <InputNumber min={0} style={{ width: 60 }} disabled/>
                            </Form.Item>
                             <p>เดือน</p>
                    </Flex>
                    </Card>
                    <br/>
                    <Card style={{marginLeft:20}}>
                        <Flex align="center" gap={8} style={{ marginLeft: 20 }}>
                            <p>ดำเนินการเก็บข้อมูลเริ่มตั้งแต่เดือน</p>
                            <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]} 
                                name="InfoGatheringStartingDate"
                                style={{ marginBottom: 0 }}
                                >
                                <DatePicker
                                    picker="month"
                                    format="MMMM YYYY"
                                    placeholder="เลือกเดือนเริ่มต้น"
                                    onChange={handleInfoDateChange}
                                    style={{ width: 160 }}
                                />
                            </Form.Item>
                            <p>จนถึงเดือน</p>
                            <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]} 
                            name="InfoGatheringEndingDate"
                            style={{ marginBottom: 0 }}
                            >
                            <DatePicker
                                picker="month"
                                format="MMMM YYYY"
                                placeholder="เลือกเดือนสิ้นสุด"
                                style={{ width: 160 }}
                                onChange={handleInfoDateChange}
                                disabledDate={(currentitem) => {
                                    const start = form.getFieldValue('InfoGatheringStartingDate');
                                    return start && currentitem < start.startOf('month');
                                  }}
                            />
                            </Form.Item>
                        </Flex>
                        <Flex align="center" gap={8} style={{ marginLeft: 20 }}>
                            <p>ระยะเวลาที่ดำเนินการเก็บข้อมูล</p>
                                <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]} 
                                    name="InfoGatheringPeriod_year"
                                    style={{ marginBottom: 0 }}
                                >
                                    <InputNumber min={0} style={{ width: 60 }} disabled/>
                                </Form.Item>
                                <p>ปี</p>
                                <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]} 
                                    name="InfoGatheringPeriod_month"
                                    style={{ marginBottom: 0 }}
                                >
                                    <InputNumber min={0} style={{ width: 60 }} disabled/>
                                </Form.Item>
                            <p>เดือน</p>
                        </Flex>
                    </Card>
                    <br/>
                    <p style={{fontWeight:'bold'}}>งบประมาณ</p>
                    <Card  style={{marginLeft:20}}>
                        <Flex align="center" gap={8} style={{ marginLeft: 20 }}>
                        <p>งบประมาณโครงการวิจัย</p>
                        <Form.Item required
                            rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={'Projectfund'} style={{ marginBottom: 0 }}>
                            <InputNumber
                                style={{ marginInline: 50, width: '10vw' }}
                                min={0}
                                precision={2}
                                suffix='บาท'
                                formatter={(value) =>
                                    value !== undefined && value !== null
                                        ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                        : '0'
                                }
                                /></Form.Item></Flex>
                        <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{marginLeft:50}} name='EthicalApprovalFee' label='ค่าธรรมเนียมการพิจารณาจริยธรรมฯ'>
                            <Radio.Group
                                style={style}
                                options={[
                                    {label:'คณาจารย์ บุคลากร ทั้งภายในและภายนอก 2,500 บาท',value:'คณาจารย์ บุคลากร ทั้งภายในและภายนอก 2,500 บาท'},
                                    {label:'นักศึกษาระดับบัณฑิตศึกษา ทั้งภายในและภายนอก 1,000 บาท',value:'นักศึกษาระดับบัณฑิตศึกษา ทั้งภายในและภายนอก 1,000 บาท'},
                                    {label:'นักศึกษาระดับปริญญาตรี ทั้งภายในและภายนอก 500 บาท',value:'นักศึกษาระดับปริญญาตรี ทั้งภายในและภายนอก 500 บาท'},
                                ]}
                            />
                        </Form.Item>
                        <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{marginLeft:50}} name='Sponsor' label='แหล่งทุนสนับสนุน (Sponsor)'>
                        <Radio.Group
                                style={style}
                                onChange={(e)=>{setSponser(e.target.value)
                                    setSponserExplanation('')
                                }}
                                options={[
                                    {value:'ทุนอุดหนุนจากภาครัฐ',label:(<>
                                        ทุนอุดหนุนจากภาครัฐ {
                                            Sponser==='ทุนอุดหนุนจากภาครัฐ'&&<>
                                            <Input
                                                value={SponserExplanation}
                                                onChange={(e)=>setSponserExplanation(e.target.value)}
                                                variant="filled"
                                                placeholder="กรุณาระบุ"
                                                style={{ width: '30vw', marginInlineStart: 12 }}/>
                                            </>
                                        }
                                    </>)},
                                    {value:'ทุนเอกชนหรือผู้ประกอบการ',label:(<>
                                        ทุนเอกชนหรือผู้ประกอบการ {
                                            Sponser==='ทุนเอกชนหรือผู้ประกอบการ'&&<>
                                            <Input
                                                value={SponserExplanation}
                                                onChange={(e)=>setSponserExplanation(e.target.value)}
                                                variant="filled"
                                                placeholder="กรุณาระบุ"
                                                style={{ width: '30vw', marginInlineStart: 12 }}/>
                                                </>
                                        }
                                    </>)},
                                    {label:'ทุนวิจัยภายในมหาวิทยาลัยวงษ์ชวลิตกุล',value:'ทุนวิจัยภายในมหาวิทยาลัยวงษ์ชวลิตกุล'},
                                    {label:'ทุนส่วนตัว',value:'ทุนส่วนตัว'},
                                    {label:'ยังไม่ได้ยื่นขอทุน',value:'ยังไม่ได้ยื่นขอทุน'},
                                    {label:'ยื่นขอแล้วอยู่ระหว่างการพิจารณา',value:'ยื่นขอแล้วอยู่ระหว่างการพิจารณา'},
                                    {value:'อื่นๆ',label:(<>
                                        อื่นๆ {
                                            Sponser==='อื่นๆ'&&<>
                                            <Input
                                                value={SponserExplanation}
                                                onChange={(e)=>setSponserExplanation(e.target.value)}
                                                variant="filled"
                                                placeholder="กรุณาระบุ"
                                                style={{ width: '30vw', marginInlineStart: 12 }}/>
                                            </>
                                        }
                                    </>)},
                                ]}
                            />
                        </Form.Item>
                    </Card>

                </div>
        },
        {
            title:'ส่วนที่ 2',
            content:
                <div style={{padding:20}}>
                    <h2>ส่วนที่ 2 การพิจารณาจริยธรรม</h2>
                  {hidingPatient&&<>
                        <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  
                        name='Invited'
                        label="ผู้ที่จะได้รับเชิญเป็นผู้ร่วมโครงการวิจัย เป็น">
                            <Checkbox.Group
                            value={selectedTypes}
                            onChange={(checkedValues) => setSelectedTypes(checkedValues as string[])}
                            options={['ผู้มีสุขภาพดี', 'ผู้ป่วย', 'อื่น ๆ']}
                            />
                        </Form.Item>

                        {selectedTypes.includes('ผู้มีสุขภาพดี') && (
                            <>
                            <Card>
                            <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'healthy', 'count']} label="จำนวน (ผู้มีสุขภาพดี)">
                                <Input type='number' placeholder="จำนวน" min={0} suffix='คน' />
                            </Form.Item>
                            <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'healthy', 'note']} label="คำอธิบาย">
                                <Input />
                            </Form.Item>
                            <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'healthy', 'age']} label="อายุ">
                                <Input placeholder="สามารถกรอกข้อมูลเป็นข้อความได้"/>
                            </Form.Item>
                            {/* <Space>
                                <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{width:'25vw'}} name={['InvitedParticipant', 'healthy', 'age_year']} label="อายุ ">
                                <Input type='number' min={0} suffix='ปี' />
                                </Form.Item>
                                <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{width:'25vw'}} name={['InvitedParticipant', 'healthy', 'age_month']} label=" ">
                                <Input type='number' min={0} suffix='เดือน'/>
                                </Form.Item>
                            </Space> */}
                            <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'healthy', 'gender']} label="เพศ">
                                <Checkbox.Group options={genderOptions} />
                            </Form.Item></Card>
                            <br/>
                            </>
                        )}

                        {selectedTypes.includes('ผู้ป่วย') && (
                            <>
                            <Card>
                            <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'patient', 'count']} label="จำนวน (ผู้ป่วย)">
                                <Input type='number' placeholder="จำนวน" min={0} suffix='คน'/>
                            </Form.Item>
                            <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'patient', 'note']} label="คำอธิบาย">
                                <Input />
                            </Form.Item>
                            <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'patient', 'age']} label="อายุ">
                                <Input placeholder="สามารถกรอกข้อมูลเป็นข้อความได้"/>
                            </Form.Item>
                            {/* <Space>
                                <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{width:'25vw'}} name={['InvitedParticipant', 'patient', 'age_year']} label="อายุ (ปี)">
                                <Input type='number' min={0} suffix='ปี'  />
                                </Form.Item>
                                <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{width:'25vw'}} name={['InvitedParticipant', 'patient', 'age_month']} label="อายุ (เดือน)">
                                <Input type='number' min={0} suffix='เดือน'/>
                                </Form.Item>
                            </Space> */}
                            <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'patient', 'gender']} label="เพศ">
                                <Checkbox.Group options={genderOptions} />
                            </Form.Item>
                            </Card>
                            <br/></>
                        )}

                        {selectedTypes.includes('อื่น ๆ') && (
                            <>
                            <Card>
                            <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'other', 'othertype']} label="โปรดระบุกลุ่มผู้ที่จะได้รับเชิญ">
                                <Input/>
                            </Form.Item> 
                            <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'other', 'note']} label="คำอธิบาย">
                                <Input />
                            </Form.Item>
                            <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'other', 'count']} label="จำนวน (อื่น ๆ)">
                                <Input type='number' placeholder="จำนวน"  min={0} suffix='คน'/>
                            </Form.Item>
                            <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'other', 'age']} label="อายุ">
                                <Input placeholder="สามารถกรอกข้อมูลเป็นข้อความได้"/>
                            </Form.Item>
                            {/* <Space>
                                <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{width:'25vw'}} name={['InvitedParticipant', 'other', 'age_year']} label="อายุ (ปี)">
                                <Input type='number' min={0}  suffix='ปี' />
                                </Form.Item>
                                <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{width:'25vw'}} name={['InvitedParticipant', 'other', 'age_month']} label="อายุ (เดือน)">
                                <Input type='number' min={0} suffix='เดือน'/>
                                </Form.Item>
                            </Space> */}
                            <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'other', 'gender']} label="เพศ">
                                <Checkbox.Group options={genderOptions} />
                            </Form.Item>
                            </Card><br/></>
                        )}
                    </> }    

                     <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  
                        name='Invited'
                        label="ผู้ที่จะได้รับเชิญเป็นผู้ร่วมโครงการวิจัย เป็น">
                            <Checkbox.Group
                            value={selectedTypes}
                            onChange={(checkedValues) => setSelectedTypes(checkedValues as string[])}
                            options={['อาสาสมัครทั่วไป', 'อาสาสมัครเด็ก อายุ 7-18 ปี', 'อาสาสมัครกลุ่มเปราะบาง']}
                            />
                        </Form.Item>   

                        {selectedTypes.includes('อาสาสมัครทั่วไป') && (
                            <>
                            <Card>
                                <p style={{fontWeight:'bold'}}>อาสาสมัครทั่วไป</p>
                            <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'normal', 'count']} label="จำนวน ">
                                <Input type='number' placeholder="จำนวน" min={0} suffix='คน' />
                            </Form.Item>
                            <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'normal', 'note']} label="คำอธิบาย">
                                <Input />
                            </Form.Item>
                            <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'normal', 'age']} label="อายุ">
                                <Input placeholder="สามารถกรอกข้อมูลเป็นข้อความได้"/>
                            </Form.Item>
                            <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'normal', 'gender']} label="เพศ">
                                <Checkbox.Group options={genderOptions} />
                            </Form.Item></Card>
                            <br/>
                            </>
                        )}

                        {selectedTypes.includes('อาสาสมัครเด็ก อายุ 7-18 ปี') && (
                            <>
                            <Card>
                                <p style={{fontWeight:'bold'}}>ข้อมูลอาสาสมัครเด็ก อายุ 7-18 ปี</p>
                            <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'kids', 'count']} label="จำนวน">
                                <Input type='number' placeholder="จำนวน" min={0} suffix='คน' />
                            </Form.Item>
                            <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'kids', 'note']} label="คำอธิบาย">
                                <Input />
                            </Form.Item>
                            <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'kids', 'age']} label="อายุ">
                                <Input placeholder="สามารถกรอกข้อมูลเป็นข้อความได้"/>
                            </Form.Item>
                            <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'kids', 'gender']} label="เพศ">
                                <Checkbox.Group options={genderOptions} />
                            </Form.Item></Card>
                            <br/>
                            </>
                        )}    

                        {selectedTypes.includes('อาสาสมัครกลุ่มเปราะบาง') && (
                            <>
                            <Card>
                                <p style={{fontWeight:'bold'}}>อาสาสมัครกลุ่มเปราะบาง</p>
                            <Form.Item required
                             rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'vulnerable', 'count']} label="จำนวน">
                                <Input type='number' placeholder="จำนวน" min={0} suffix='คน' />
                            </Form.Item>
                            <Form.Item required
                            rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'vulnerable', 'note']} label="คำอธิบาย">
                                    <TextArea                             
                                    autoSize={{ minRows: 3, maxRows: 5 }}
                                    placeholder="เช่น หญิงตั้งครรภ์ ผู้สูงอายุ เด็กเล็ก ผู้ป่วยมะเร็ง ผู้ป่วยเด็ก ผู้ป่วยสมองเสื่อม ผู้ต้องขัง ทหารเกณฑ์ อาชีพผิดกฎหมาย แรงงานต่างด้าวเข้าประเทศแบบผิดกฎหมาย" />
                                </Form.Item>
                                <Form.Item required
                            rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'vulnerable', 'age']} label="อายุ">
                                    <Input placeholder="สามารถกรอกข้อมูลเป็นข้อความได้"/>
                                </Form.Item>
                                <Form.Item required
                            rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name={['InvitedParticipant', 'vulnerable', 'gender']} label="เพศ">
                                    <Checkbox.Group options={genderOptions} />
                                </Form.Item></Card>
                                <br/>
                            </>
                        )}    

                    <Form.Item required
                        rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{ fontWeight: 'bold' }} name="IsbloodDraw" label="การเจาะเลือดผู้ป่วย/อาสาสมัคร">
                            <Radio.Group
                            style={{fontWeight:'normal'}}
                            options={[
                                { label: 'มี', value: 'มี' },
                                { label: 'ไม่มี', value: 'ไม่มี' },
                            ]}
                            />
                    </Form.Item>
                    <AnimatePresence mode="wait">
                    {IsbloodDraw=='มี'&&
                    <motion.div
                        key="bloodCard"
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.3 }}
                        >
                        <Card>
                            <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  name='bloodDrawObjective' label="โปรดระบุวัตถุประสงค์ของการเจาะเลือด">
                                <TextArea placeholder='ระบุวัตถุประสงค์ในการเจาะเลือด' autoSize  />
                            </Form.Item>
                            <Space>
                                <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{width:'25vw'}} name='bloodDrawTimes' label="จำนวน">
                                    <Input type='Number'  min={0} suffix='ครั้ง'/>
                                </Form.Item>
                                <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{width:'20vw'}} name='bloodDrawAmount' label="ครั้งละ">
                                    <Input type='Number' min={0} />
                                </Form.Item>
                                <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{width:'5vw'}} name='bloodDrawUnit' label="หน่วย">
                                    <Input />
                                </Form.Item>
                            </Space>
                            <br/>
                            <Space>
                            <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{width:'25vw'}} name='bloodDrawTotalTimes' label="ทั้งหมด">
                                <Input type='Number' min={0} suffix='ครั้ง'/>
                            </Form.Item>
                            <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{width:'25vw'}} name='bloodDrawTotalMonth' label="ต่อ ">
                                <Input type='Number' min={0} suffix='เดือน' />
                            </Form.Item>
                            </Space>

                        </Card>
                   </motion.div>
                   }</AnimatePresence>
                    <br/>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} name='IsInvasiveProcedure' label='หัตถการอื่นที่มีการรุกล้ำร่างกาย (Invasive Procedure)  '>
                        <Radio.Group style={style} 
                        value={IsInvasiveProcedure}
                        onChange={(e)=>setIsInvasiveProcedure(e.target.value)}
                        options={[
                            {
                                label:'มี',value:'มี'
                            },{
                                label:'ไม่มี',value:'ไม่มี'
                            }
                        ]}/>  
                    </Form.Item>
                    <AnimatePresence>
                    {IsInvasiveProcedure=='มี'&&
                        <motion.div
                            key="bloodCard"
                            initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -20 }}
                            transition={{ duration: 0.3 }}
                            >
                            <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} name='InvasiveProcedureSummary' label='กรุณาแสดงรายละเอียดเกี่ยวกับหัตถการของท่านโดยสรุป'>
                                <TextArea placeholder="กรุณาแสดงรายละเอียดเกี่ยวกับหัตถการของท่านโดยสรุป" autoSize style={{marginLeft:50}}/>
                            </Form.Item>
                        </motion.div>}
                    </AnimatePresence>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} name='RiskAndUncomfortableFactor' label='บรรยายความเสี่ยงและความไม่สะดวกสบายที่ผู้ป่วย/อาสาสมัคร จะได้รับจากการร่วมโครงการ (อธิบายให้ชัดเจน)'>
                        <TextArea autoSize style={{marginLeft:50,width:'60vw'}} placeholder="กรุณาอธิบายให้ชัดเจน เช่น ความเสี่ยงด้านการรักษาความลับ ด้านสุขภาพกายและใจ ด้านค่าใช้จ่ายและเด้านเวลา"/>
                    </Form.Item>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} name='DefensiveMeasure' label='บรรยายวิธีการหรือมาตรการที่จัดเตรียมเพื่อลดความเสี่ยงและความไม่สะดวกสบายที่ผู้ป่วย/อาสาสมัคร จะได้รับจากการร่วมโครงการ (กรุณาบรรยายให้สอดคล้องกับข้อข้างต้น)'>
                        <TextArea autoSize style={{marginLeft:50}} placeholder="กรุณาอธิบายให้ชัดเจนและสอดคล้องกับการบรรยายความเสี่ยงและความไม่สะดวกสบาย"/>
                    </Form.Item>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} name='ExpenseCoverage' label='ถ้าหากเกิดอันตราย/ความเสียหายต่อผู้ถูกวิจัย ที่เป็นผลสืบเนื่องโดยตรงจากการวิจัยในผู้ป่วย ผู้เสนอโครงการและ/หรือผู้ให้ทุนสนับสนุน
                    การวิจัยจะให้การรักษาจนกลับคืนสภาพเดิม หรือชดเชยความเสียหายที่ไม่สามารถรักษาให้คืนสู่สภาพเดิมได้ ตลอดจน
                    ให้ความคุ้มครองด้านค่าใช้จ่ายแก่ผู้ถูกวิจัยอย่างไรบ้าง?'>
                        <Radio.Group
                            style={style}
                            options={[
                                {
                                    label:'ผู้อุปถัมภ์มีให้ดังเอกสารแนบมาพร้อมโครงการ',value:'ผู้อุปถัมภ์มีให้ดังเอกสารแนบมาพร้อมโครงการ' 
                                },{
                                    label:'ผู้อุปถัมภ์ไม่มีให้ แต่ผู้วิจัยจะดูแลรักษาดังปรากฏในหนังสือแสดงความยินยอมหรือข้อมูลสำหรับผู้ป่วย/อาสาสมัคร',value:'ผู้อุปถัมภ์ไม่มีให้ แต่ผู้วิจัยจะดูแลรักษาดังปรากฏในหนังสือแสดงความยินยอมหรือข้อมูลสำหรับผู้ป่วย/อาสาสมัคร'
                                },{
                                    label:'ทั้งผู้อุปถัมภ์และผู้วิจัยไม่มีให้',value:'ทั้งผู้อุปถัมภ์และผู้วิจัยไม่มีให้'
                                },
                            ]}/>
                    </Form.Item>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} name='AcceptanceUnderstanding' label='ผู้วิจัยและผู้ร่วมงานทุกคนในโครงการทราบโดยผ่านการอบรมจริยธรรมการวิจัยในมนุษย์และเข้าใจข้อตกลง หลักความเคารพ
                        ในบุคคล หลักคุณประโยชน์ และหลักความยุติธรรม  หรือไม่ 
                        '><Radio.Group
                        style={style}
                        options={[
                            {
                                label:'ทราบและเข้าใจทุกคน',value:' ทราบและเข้าใจทุกคน' 
                            },{
                                label:'ทราบและเข้าใจเป็นบางทุกคน',value:'ทราบและเข้าใจเป็นบางทุกคน'
                            },{
                                label:'ไม่ทราบเลย',value:'ไม่ทราบเลย'
                            },
                        ]}/>
                    </Form.Item>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} name='IsCountryReligionRiskFactor' label='โครงการวิจัยเกี่ยวข้องหรืออาจมีผลกระทบกระเทือนต่อศาสนา ความเชื่อ ขนบธรรมเนียมประเพณี หรือ วัฒนธรรมอันดีงามของประเทศไทย 
                    หรือของท้องถิ่นที่ทำการวิจัยอยู่หรือไม่'>
                        <Radio.Group
                        value={IsCountryReligionRiskFactor}
                        onChange={(e)=>{setIsCountryReligionRiskFactor(e.target.value)}}
                        style={style}
                        options={[
                            {
                                label:'ไม่เกี่ยวข้อง/ไม่มี',value:'ไม่เกี่ยวข้อง/ไม่มี' 
                            },{
                                value:'เกี่ยวข้อง/มี',label:(
                                    <>
                                        เกี่ยวข้อง/มี {
                                        IsCountryReligionRiskFactor==='เกี่ยวข้อง/มี'&&(
                                                <>ระบุ<Input
                                                value={CountryReligionRiskFactorList}
                                                onChange={(e)=>setIsCountryReligionRiskFactorList(e.target.value)}
                                                variant="filled"
                                                placeholder="กรุณาระบุ"
                                                style={{ width: '30vw', marginInlineStart: 12 }}
                                              /></>
                                            )
                                            }
                                        
                                    </>
                                )
                            },
                        ]}/>
                    
                    </Form.Item>
                </div>
        },
        {
            title:'ส่วนที่ 3',
            content:
                <div style={{padding:20}}>
                    <h2>ส่วนที่ 3 ยา</h2>
                    <Form.Item required
                    name='medProgramGiven'
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} label='โครงการวิจัยนี้มีการให้ยาและหรือสิ่งทดลอง 
                        (เช่น โปรแกรมการส่งเสริมสุขภาพ การนวด การใช้สมุนไพร เป็นต้น) 
                        แก่ผู้ป่วย/อาสาสมัครหรือไม่ '>
                        <Radio.Group
                        style={style}
                        value={IsMedicine}
                        onChange={(e)=>setIsMedicine(e.target.value)}
                        options={[
                            {
                                label:'ไม่มี',value:'ไม่มี' 
                            },{
                                value:'มี',label:(
                                    <span>
                                    มี {IsMedicine === 'มี' && (<>
                                        ระบุ
                                        <Input
                                          value={MedicineInfo}
                                          onChange={(e)=>setMedicineInfo(e.target.value)}
                                          variant="filled"
                                          placeholder="กรุณาระบุเหตุผลประกอบ"
                                          style={{ width: '30vw', marginInlineStart: 12 }}
                                        /></>
                                      )}</span>
                                )
                            },
                        ]}/>
                    </Form.Item>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} name='applicableFactor' label='โครงการวิจัยนี้เกี่ยวข้องกับ'>
                        <Checkbox.Group style={style}
                            options={[
                                {
                                    label:'การสร้าง การก่อให้เกิดการเปลี่ยนแปลงตลอดจนการจัดเก็บสารพันธุกรรมของสิ่งมีชีวิตใด ๆ',value:'การสร้าง การก่อให้เกิดการเปลี่ยนแปลงตลอดจนการจัดเก็บสารพันธุกรรมของสิ่งมีชีวิตใด ๆ' 
                                },{
                                    label:'การใช้สารกัมมันตรังสี',value:'การใช้สารกัมมันตรังสี'
                                },{
                                    label:'การเปลี่ยนแปลงสิ่งแวดล้อม',value:'การเปลี่ยนแปลงสิ่งแวดล้อม'
                                },{
                                    label:'ไม่เกี่ยวข้องกับรายการข้างต้น',value:'ไม่เกี่ยวข้องกับรายการข้างต้น'
                                },
                            ]}/>
                    </Form.Item>
                    <Form.Item  style={{fontWeight:'bold'}} name='applicableFactorDesc' label='กรุณาอธิบายว่าโครงการของท่านเกี่ยวข้องกับเรื่องข้างต้นอย่างใด'>
                        <TextArea
                            
                            style={{marginLeft:50,width:'60vw'}} 
                            placeholder="ถ้าเกี่ยวข้อง กรุณาอธิบายว่าเกี่ยวข้องอย่างไร และมีมาตรการลดภัยอัตรายอย่างไร" 
                            autoSize={{ minRows: 3, maxRows: 5 }}
                            />
                    </Form.Item>
                    
                </div>
        },
        {
            title:'ส่วนที่ 4',
            content:
                <div style={{padding:20}}>
                    <h2>ส่วนที่ 4 ทรัพย์สินทางปัญญาและอื่น ๆ</h2>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} name='IsCommercialInterlectualProperty' label='ผลของการศึกษาวิจัย (Results) หรือวัสดุใด ๆ (Materials) ที่เก็บจากผู้ป่วยหรือที่จะเป็นผลลัพธ์จากการวิจัยอาจมีคุณค่าในแง่ทรัพย์สินทาง
การค้าและ/หรือทรัพย์สินทางปัญญา (เช่น สิทธิบัตร) หรือไม่ อย่างไร'>
                         <Radio.Group
                            style={style}
                            key={ResMat}
                            value={ResMat}
                            onChange={ResMatOnChange}
                            >
                            <Radio value="ไม่มี">ไม่มี</Radio>
                            <Radio value="มี">
                                มี
                                {ResMat === 'มี' && (
                                <>
                                    &nbsp;เพราะ
                                    <Input
                                    value={ResMatReason}
                                    variant="filled"
                                    onChange={(e) => setResMatReason(e.target.value)}
                                    placeholder="กรุณาระบุเหตุผลประกอบ"
                                    style={{ width: '30vw', marginInlineStart: 12 }}
                                    />
                                </>
                                )}
                            </Radio></Radio.Group>
                    </Form.Item>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} name='ProgressReport' label='ผู้วิจัยจะส่งรายงานความก้าวหน้า (Progress Report) มายังคณะกรรมการเมื่อ'>
                        <Radio.Group style={style} options={[
                            {label:'ทุก 6 เดือน ในกรณีโครงการวิจัย 1 ปี หรือมากกว่า',value:'ทุก 6 เดือน ในกรณีโครงการวิจัย 1 ปี หรือมากกว่า'},
                            {label:'ทุกกึ่งหนึ่งของระยะเวลาการวิจัยที่ไม่ถึง  1 ปี',value:'ทุกกึ่งหนึ่งของระยะเวลาการวิจัยที่ไม่ถึง  1 ปี'},
                        ]}/>
                    </Form.Item>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} name='PlagiarismPer' label='การเขียนโครงร่างงานวิจัยทั้งหมดอาจมีข้อมูลของผู้อื่นมาดัดแปลง แก้ไข หรือทำซ้ำ ต้อง ไม่เกินร้อยละ 30 ของเนื้อหาทั้งหมด (เลือกอย่างใดอย่างหนึ่ง)'>
                        <Radio.Group
                            style={style}
                            value={plagiaisme}
                            onChange={plagiaismeOnChange}
                            options={[
                                {
                                    label:'งานวิจัยนี้ไม่ได้ใช้ปัญญาประดิษฐ์เป็นผู้ช่วยในการพัฒนาโครงร่างงานวิจัย',value:'งานวิจัยนี้ไม่ได้ใช้ปัญญาประดิษฐ์เป็นผู้ช่วยในการพัฒนาโครงร่างงานวิจัย'
                                },
                                {
                                    value:'งานวิจัยนี้ได้ใข้ปัญญาประดิษฐ์ช่วยพัฒนาโครงร่างงานวิจัย แต่ปฏิบัติตามหลักจริยธรรมการใช้ปัญญาประดิษฐ์อย่างเคร่งคัด',label:'งานวิจัยนี้ได้ใข้ปัญญาประดิษฐ์ช่วยพัฒนาโครงร่างงานวิจัย แต่ปฏิบัติตามหลักจริยธรรมการใช้ปัญญาประดิษฐ์อย่างเคร่งคัด'
                                },
                             
                            ]}/>
                    </Form.Item>
                </div>
        },
        {
            title:'ส่วนที่ 5',
            content:
                <div style={{padding:20}}>
                    <h2>ส่วนที่ 5 คำรับรองจากผู้วิจัย</h2>
                    <Form.Item name='Accepted'>
                    <p style={{fontWeight:'bold',marginLeft:'3vw', marginBottom: '2px 0',marginTop:'2px 0'}}>
                        1. ข้าพเจ้าได้ตรวจสอบความถูกต้องของข้อมูลทั้งหมดที่นำเสนอต่อคณะกรรมการจริยธรรมการวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุลด้วยตนเอง</p> 
                    <p style={{fontWeight:'bold',marginLeft:'3vw', marginBottom: '2px 0',marginTop:'2px 0'}}>
                        2. ข้าพเจ้าจะไม่เริ่มดำเนินการวิจัยจนกว่าจะได้รับผลการพิจารณาจากคณะกรรมการจริยธรรมการวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุล</p> 
                    <p style={{fontWeight:'bold',marginLeft:'3vw', marginBottom: '2px 0',marginTop:'2px 0'}}>
                        3. ข้าพเจ้าทราบว่าหากมีการแก้ไข/ปรับปรุงโครงการวิจัย นอกเหนือจากที่ยื่นขอรับการพิจารณาครั้งนี้ ข้าพเจ้าจะต้องรายงาน โดยใช้แบบฟอร์มการแก้ไขเพิ่มเติมโครงร่างการวิจัย(ถ้ามี), การรายงานเหตุไม่พึงประสงค์ชนิดร้ายแรงหรือไม่คาดคิดมาก่อน (ถ้ามี), การรายงานการดำเนินงานที่เบี่ยงเบนหรือไม่ปฏิบัติตามโครงร่างการวิจัยที่ได้รับร้อง (ถ้ามี)
                    </p> 
                    <p style={{fontWeight:'bold',marginLeft:'3vw', marginBottom: '2px 0',marginTop:'2px 0'}}>
                        4. ข้าพเจ้าจะรายงานการแจ้งปิดโครงการวิจัยต่อคณะกรรมการจริยธรรมการวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุล โดยใช้แบบฟอร์มรายงานการสิ้นสุดโครงการวิจัยเมื่อดำเนินโครงการวิจัยเสร็จสิ้นแล้ว</p>
                    </Form.Item>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} name='Acceptance'>
                        <Radio.Group
                            style={style}
                            options={[
                                {value:'รับรอง',label:'รับรอง'},
                                {value:'ไม่รับรอง',label:'ไม่รับรอง'},
                            ]}/>
                    </Form.Item>
                    <Form.Item required
                    rules={[{ required: true, message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }]}  style={{fontWeight:'bold'}} name='LangRecieve' label='ข้าพเจ้าต้องการหนังสือรับรองจากคณะกรรมการเป็นฉบับ '>  
                        <Checkbox.Group
                            style={style}
                            options={[
                                {value:'ภาษาไทย',label:'ภาษาไทย'},
                                {value:'ภาษาอังกฤษ',label:'ภาษาอังกฤษ'},
                                {value:'ไม่ต้องการแบบฟอร์มของคณะกรรมการแต่จะแนบเอกสารมาให้ลงนาม',label:'ไม่ต้องการแบบฟอร์มของคณะกรรมการแต่จะแนบเอกสารมาให้ลงนาม'},
                            ]}/>
                    </Form.Item>
                </div>
        }
        
    ]

    const contentStyle: React.CSSProperties = {
        backgroundColor: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        border: `1px dashed ${token.colorBorder}`,
        marginLeft: 20,
        overflowY: 'auto',
        overflowX: 'hidden',     
        paddingRight: 16,       
        boxSizing: 'border-box', 
      };

      const next = () => {
        setCurrent((prev) => prev + 1);
      
        if (current === 0) {
            console.log('is here?'+current)
          setTimeout(() => {
            form.scrollToField('Invited', {
              behavior: 'smooth',
              block: 'center',
            });
          }, 200); 
        }else if (current === 1) {
          setTimeout(() => {
            form.scrollToField('medProgramGiven', {
              behavior: 'smooth',
              block: 'center',
            });
          }, 200); 
        }else if (current === 2) {
            setTimeout(() => {
              form.scrollToField('IsCommercialInterlectualProperty', {
                behavior: 'smooth',
                block: 'center',
              });
            }, 200); 
        }
        else if (current === 2) {
        setTimeout(() => {
            form.scrollToField('Accepted', {
            behavior: 'smooth',
            block: 'center',
            });
        }, 200); 
        }
        else{
            console.log('is not here?'+current)
        }
      };
    
      const prev = () => {
        setCurrent(current - 1);
      };

      function handleNextPart(){
        navigate('/VU_HREC/VolunteerForm')
      }
    

    return(
        <>
            <h1 style={{fontSize:40,marginBottom:0}}>แบบฟอร์มการยื่นคำขอพิจารณาจริยธรรมวิจัยในมนุษย์</h1>
            <h1 style={{fontSize:30,marginTop:0,marginBottom:10}}>มว.จ.001 คำขอรับรองการพิจารณาจริยธรรมการวิจัยในมนุษย์</h1>
            <hr/>
            <Form wrapperCol={{ span: 50 }}
                form={form}
                layout="vertical">
                <Steps
                current={current}
                onChange={onChange}
                items={ReqStep}/>
                <br/>
                <Card style={contentStyle}>{ReqStep[current].content}</Card>
                <br/>
                <Flex justify='space-between'>
                {
                    current==0 &&<><Button type="primary" onClick={() => navigate(`/VU_HREC/ProjectInfo`)}>
                    กลับหน้าแสดงข้อมูล
                    </Button>
                    </>
                }
                {current >0 &&<Button onClick={async() => prev()}>
                    ก่อนหน้า
                </Button>}
                {
                    current<4&&<Button type="primary" onClick={async()=>
                        {try {
                            await form.validateFields();
                            await saveProtoptype();
                            next();
                          } catch (error: any) {
                            // 👈 Fix: type the error as 'any' (or 'unknown' + check below)
                            console.log("Validation failed:", error);
                  
                            if (error && error.errorFields) {
                              form.scrollToField(error.errorFields[0].name, {
                                behavior: "smooth",
                                block: "center",
                              });
                            }
                  
                            message.error("กรุณากรอกข้อมูลให้ครบถ้วนก่อนดำเนินการต่อ");
                          }
                        }}>บันทึกและไปหน้าถัดไป</Button>
                    ||
                    <Button onClick={async()=>{
                        await form.validateFields();
                        saveProtoptype();
                        handleNextPart()}}>บันทึกแล้วไปส่วนถัดไป</Button>
                }
                </Flex>
            </Form>
        </>
    )
}